module.exports = __webpack_public_path__ + "static/media/instagram.a9d8bd71.svg";